export default function sanitizeToken(token) {
  let result = token;
  if (typeof result === 'object') {
    var _result$token, _result;
    return (_result$token = (_result = result) == null ? void 0 : _result.token) != null ? _result$token : '';
  }
  try {
    var _result2;
    const parsedToken = JSON.parse((_result2 = result) != null ? _result2 : '');
    // web-app is storing the token as object
    if (typeof parsedToken === 'object' && parsedToken != null && parsedToken.token) {
      result = parsedToken.token;
    } else {
      // ui-next is storing token as string
      result = result && result.replace(/"/g, '');
    }
  } catch (err) {
    result = result && typeof result === 'string' ? result.replace(/"/g, '') : '';
  }
  return String(result);
}